<template>
  <div id="create_user">
    <v-container grid-list-xl fluid>
      <!-- mini statistic start -->
      <v-tabs v-model="active" color="white" slider-color="primary" height="120%" grow>
        <v-layout row wrap>
          <v-tab @click.native="step = 1">
            <v-flex xl12 lg12 md12 sm12 xs12>
              <mini-statistic
                step="1"
                @click.native="step = 1"
                icon="fa fa-user-secret"
                v-bind:title="total_farmer"
                sub-title="Farmers"
                color="primary"
              ></mini-statistic>
            </v-flex>
          </v-tab>
          <v-tab @click.native="step = 2">
            <v-flex xl12 lg12 md12 sm12 xs12>
              <mini-statistic
                step="2"
                @click.native="step = 2"
                icon="fa fa-truck"
                v-bind:title="total_driver"
                sub-title="Drivers"
                color="primary"
              ></mini-statistic>
            </v-flex>
          </v-tab>
          <v-tab @click.native="step = 3">
            <v-flex xl12 lg12 md12 sm12 xs12>
              <mini-statistic
                step="3"
                @click.native="step = 3"
                icon="store"
                v-bind:title="total_customer"
                sub-title="Customers"
                color="primary"
              ></mini-statistic>
            </v-flex>
          </v-tab>
        </v-layout>
        <v-spacer></v-spacer>
      </v-tabs>

      <v-layout row wrap>
        <v-flex sm12>
          <v-stepper v-model="step">
            <v-stepper-items>
              <v-stepper-content step="1">
                <data_table1 @farmer="farmer()" />
              </v-stepper-content>
              <v-stepper-content step="2">
                <data_table2 @driver="driver()" />
              </v-stepper-content>
              <v-stepper-content step="3">
                <data_table3 @customer="customer()" />
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import MiniStatistic from "@/components/widget/mini_statistic";
import data_table1 from "@/components/user_control/datatable1";
import data_table2 from "@/components/user_control/datatable2";
import data_table3 from "@/components/user_control/datatable3";

export default {
  components: {
    MiniStatistic,
    data_table1,
    data_table2,
    data_table3
  },
  data() {
    return {
      step: 1,
      total_farmer: "0",
      total_driver: "0",
      total_customer: "0",
      baseUrl: baseUrl
    };
  },

  created() {
    this.farmer();
    this.driver();
    this.customer();
  },
  methods: {
    farmer() {
      const params = new URLSearchParams();
      params.append("getCountTotalFarmerList", "getCountTotalFarmerList");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/user/user.php",
        data: params
      }).then(response => {
        this.total_farmer = response.data.data;
      });
    },
    driver() {
      const params = new URLSearchParams();
      params.append("getCountTotalDriverList", "getCountTotalDriverList");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/user/user.php",
        data: params
      }).then(response => {
        this.total_driver = response.data.data;
      });
    },
    customer() {
      const params = new URLSearchParams();
      params.append("getCountTotalCustomerList", "getCountTotalCustomerList");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/user/user.php",
        data: params
      }).then(response => {
        this.total_customer = response.data.data;
      });
    }
  }
};
</script>

      
        